import React from 'react'
import { Box, Typography, Paper, Avatar, useTheme } from '@mui/material'
import moment from 'moment'

const ChatMessage = ({ message, isMe }) => {
  const theme = useTheme()
  const messageAttachments = Array.isArray(message?.attachments)
    ? message.attachments.filter(Boolean)
    : []

  return (
    <Box
      display="flex"
      flexDirection={isMe ? 'row-reverse' : 'row'}
      alignItems="flex-end"
      mb={2}
      sx={{ width: '100%' }}>
      {!isMe && (
        <Avatar
          sx={{
            width: 32,
            height: 32,
            mr: 1,
            mb: 0.5,
            bgcolor: theme.palette.secondary.main,
            fontSize: '0.8rem'
          }}>
          U
        </Avatar>
      )}
      <Box sx={{ maxWidth: '75%', minWidth: '100px' }}>
        <Paper
          elevation={1}
          sx={{
            p: 1.5,
            borderRadius: isMe ? '20px 20px 4px 20px' : '20px 20px 20px 4px',
            bgcolor: isMe
              ? theme.palette.primary.main
              : theme.palette.grey[200],
            color: isMe ? '#fff' : theme.palette.common.black
          }}>
          {message.content && (
            <Typography
              variant="body2"
              sx={{
                fontWeight: isMe ? '500' : '400',
                mb: messageAttachments.length ? 1 : 0
              }}>
              {message.content}
            </Typography>
          )}
          {messageAttachments.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
              {messageAttachments.map((attachment, index) => (
                <Box key={`${message._id || 'msg'}_${index}`}>
                  <Box
                    component="img"
                    src={attachment}
                    alt="attachment"
                    sx={{
                      width: 220,
                      maxWidth: '100%',
                      borderRadius: 1.5,
                      border: `1px solid ${
                        isMe
                          ? 'rgba(255, 255, 255, 0.35)'
                          : theme.palette.grey[300]
                      }`,
                      display: 'block'
                    }}
                  />
                </Box>
              ))}
            </Box>
          )}
        </Paper>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 0.5,
            textAlign: isMe ? 'right' : 'left',
            px: 1,
            color: theme.palette.text.disabled,
            fontWeight: '500'
          }}>
          {moment(
            isNaN(message.createdAt)
              ? message.createdAt
              : parseInt(message.createdAt)
          ).format('LT')}
        </Typography>
      </Box>
    </Box>
  )
}

export default ChatMessage
